function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "clock--orange");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard",
  transform: "translate(-44.000000, -38.000000)",
  fill: "#EF7713"
}, React.createElement("path", {
  d: "M52,38 C56.418278,38 60,41.581722 60,46 C60,50.418278 56.418278,54 52,54 C47.581722,54 44,50.418278 44,46 C44,41.581722 47.581722,38 52,38 Z M52,39.8823529 C48.6213168,39.8823529 45.8823529,42.6213168 45.8823529,46 C45.8823529,49.3786832 48.6213168,52.1176471 52,52.1176471 C55.3786832,52.1176471 58.1176471,49.3786832 58.1176471,46 C58.1176471,42.6213168 55.3786832,39.8823529 52,39.8823529 Z M52,40.9411765 C52.479813,40.9411765 52.8757666,41.3002213 52.9338434,41.7642938 L52.9411765,41.8823529 L52.9411765,46.0070588 L54.7738481,46.9228921 C55.2000256,47.1359808 55.3938878,47.6287803 55.2441848,48.0675413 L55.194755,48.1856128 C54.9622945,48.6505337 54.3969552,48.8389802 53.9320343,48.6065197 L51.5790931,47.4300491 L51.5766227,47.4288095 C51.4683964,47.374497 51.3718368,47.299339 51.2923754,47.2088027 C51.2762469,47.1907484 51.2611746,47.1721381 51.2468685,47.1530305 C51.2383203,47.1413942 51.2300192,47.1298014 51.221979,47.1180165 C51.210552,47.1013609 51.1994875,47.0838815 51.1890222,47.0660822 C51.1771506,47.0460263 51.1662714,47.0259499 51.1561171,47.0054505 C51.1530532,46.9988961 51.1496917,46.991877 51.1464181,46.9848193 C51.1187323,46.9257034 51.0973032,46.8636365 51.0825215,46.7990359 C51.0772552,46.7752877 51.0728277,46.7520462 51.0692764,46.7286422 C51.0681643,46.7215738 51.0671145,46.7139484 51.0661566,46.7062945 L51.0638323,46.6863358 C51.0611165,46.6606525 51.0594521,46.6348126 51.0588235,46.608882 L51.0588235,46.5882353 L51.0588235,41.8823529 C51.0588235,41.3625555 51.4802026,40.9411765 52,40.9411765 Z",
  id: "clock--orange"
})));

var SvgClockOrange = function SvgClockOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClockOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock--orange.7768e0b3.svg";
export { ForwardRef as ReactComponent };